import {
    FormTab,
    Datagrid,
    AutocompleteInput,
    List,
    TextField,
    Edit,
    Filter,
    Create,
    TextInput,
    DateInput,
    DateField,
    ReferenceInput
} from "ra-ui-materialui";
import moment from "moment";
import {
    useNotify,
    useRedirect,
    useMutation,
    TabbedForm
} from "react-admin";

import { useState, useEffect, useCallback } from "react";
import { TabsUseStyles } from "../App";
import { CustomToolbarPermissions, PostBulkActionButtonsPermision } from "./utils";

import { getObjectiveStatus } from "../services/master-tables.service";
import { getArea} from "../services/master-tables.service";


/* -------------------------------------------------------
   VALIDACIÓN
------------------------------------------------------- */
const validateObjective = (values) => {
    const errors = {};
   if (!values.objective) errors.objective = "Requerido";
    if (!values.areaId) errors.areaId = "Requerido";
    if (!values.objectiveStatusId) errors.objectiveStatusId = "Requerido";
    if (!values.clientId) errors.objectiveStatusid = "Requerido"; 
    return errors;
};

/* -------------------------------------------------------
   LISTA
------------------------------------------------------- */

export const ObjectiveList = props => {

    const [setAreas] = useState([]);
    const [setSelectedAreaId] = useState(null);
    const [setCurrentArea] = useState(null); 
   useEffect(() => {
      getArea().then(res => {
            const areaList = res?.elements || [];
            const sortedAreas = areaList.sort((a, b) => (a.order - b.order));
            setAreas(sortedAreas);
            // Si hay áreas, selecciona la primera al cargar
            if (sortedAreas.length > 0) {
                setSelectedAreaId(sortedAreas[0].id);
                setCurrentArea(sortedAreas[0]);
            }
        });

        //fetchScales();
        // eslint-disable-next-line
    }, []);

   




    return (
        <List bulkActionButtons={props?.permissions?.objective?.delete ? <PostBulkActionButtonsPermision perm="objectives.delete" /> : false} exporter={false} sort={{ field: 'Id', order: 'DESC' }} filters={<ObjectiveFilter />} filterDefaultValues={{}}  {...props}>
            <Datagrid rowClick="edit" isRowSelectable={record => props?.permissions?.objective?.delete}>
                <TextField source="id" label="Id" />
                <TextField source="objective" label="Objetivo" />
                <TextField source="description" label="Descripción" />
                <TextField source="areaName" label="Área" />
                <TextField source="objectiveStatusName" label="Estado" />
                <TextField source="clientName" label="Persona Usuaria" />
                <TextField source="contractName" label="Contrato" />
                <DateField source="createdDate" label="Fecha creación" />
                <DateField source="targetDate" label="Fecha ojetivo" />


            </Datagrid>
        </List>
    );
}

/* -------------------------------------------------------
   CREAR
------------------------------------------------------- */
/* export const ObjectiveCreate = (props) => (
    <Create {...props} mutationMode="pessimistic">
        <ObjectiveForm mode="create" {...props} />
    </Create>
); */

export const ObjectiveCreate = (props) => {

    return (
        <Create mutationMode="pessimistic" {...props}>
            {ObjectiveForm(props)}
        </Create>
    )
};

/* -------------------------------------------------------
   EDITAR
------------------------------------------------------- */


export const ObjectiveEdit = (props) => {

    return (
        <Edit title={null} mutationMode="pessimistic" {...props} transform={transformObjectiveEdit}>
            {ObjectiveForm(props, 'edit')}
        </Edit>
    )
};




/* const ObjectiveTitle = ({ record }) => {
    if (!record) return <span />;
    // Los registros de escala tienen clientName/scaleName, no 'name'
    const title = 'hola'
    return <span>{title}</span>;
}; */
/* -------------------------------------------------------
   FORMULARIO
------------------------------------------------------- */

const ObjectiveForm = (props, mode = 'create') => {

    const [areas, setAreas] = useState([]);
    const [setSelectedAreaId] = useState(null);
    const [setCurrentArea] = useState(null); 
   useEffect(() => {


        getArea().then(res => {
            const areaList = res?.elements || [];
            const sortedAreas = areaList.sort((a, b) => (a.order - b.order));
            setAreas(sortedAreas);
            // Si hay áreas, selecciona la primera al cargar
            if (sortedAreas.length > 0) {
                setSelectedAreaId(sortedAreas[0].id);
                setCurrentArea(sortedAreas[0]);
            }
        });

        //fetchScales();
        // eslint-disable-next-line
    }, []);


    const [objectiveStatus, setObjectiveStatus] = useState([]);
    const [setSelectedObjectiveStatusId] = useState(null);
    const [setCurrentObjectiveStatus] = useState(null); 
    useEffect(() => {
      getObjectiveStatus().then(res => {
            const objectiveStatusList = res?.elements || [];
            const sortedObjectiveStatus = objectiveStatusList.sort((a, b) => (a.order - b.order));
            setObjectiveStatus(sortedObjectiveStatus);
             
            // Si hay áreas, selecciona la primera al cargar
            if (sortedObjectiveStatus.length > 0) {
                setSelectedObjectiveStatusId(sortedObjectiveStatus[0].id);
                setCurrentObjectiveStatus(sortedObjectiveStatus[0]);
            }
        });

        //fetchScales();
        // eslint-disable-next-line
    }, []); 


    const classes = TabsUseStyles();

    const redirect = useRedirect();
    const notify = useNotify()

    const [mutate] = useMutation();
   
    const save = useCallback(
        async (values) => {
            try {
                const res = await mutate({
                    type: mode === 'create' ? 'create' : 'update',
                    resource: 'objectives',
                    payload: { data: mode === 'create' ? transformObjectiveCreate(values) : transformObjectiveEdit(values) },
                }, { returnPromise: true });
                notify(`ra.notification.${mode === 'create' ? 'created' : 'updated_item'}`)
                if (mode === 'create') {
                    redirect('edit', props.basePath, res.data.id, res.data)
                } else {
                    redirect('list', props.basePath)
                }
            } catch (error) {
                if (error.error && error.error.code === 4002) {
                    notify(error.error.message, 'error')
                    return {
                        password: error.error.message
                    };
                }
                if (error.error && error.error.code === 4003) {
                    return {
                        name: error.error.message
                    };
                }
                if (error.error && error.error.code === 4001) {
                    return {
                        email: error.error.message
                    };
                }
                notify('ra.notification.http_error', 'warning')
            }
        },
        [mutate, mode, notify, props.basePath, redirect],
    );

    return (
        
        <TabbedForm classes={classes} save={save} validate={validateObjective} toolbar={<CustomToolbarPermissions perm="objectives.delete" />}>
            <FormTab label="Datos Generales" contentClassName="tab-container">
                <TextInput source="objective" label="Objetivo"  /> 
                <TextInput label="Descripción" source="description"  />
                <DateInput label="Fecha ojetivo" source="targetDate" />
                
                {
                    areas ?
                        <AutocompleteInput
                            label="Área"
                            source="areaId"
                            choices={areas}
                            optionText="value"
                            optionValue="id"
                            options={{ InputProps: { autoComplete: 'off' } }}
                            resettable={true}
                        />
                        : null
                }
                {
                    objectiveStatus ?
                        <AutocompleteInput
                            label="Estado del Objetivo"
                            source="objectiveStatusId"
                            choices={objectiveStatus}
                            optionText="value"
                            optionValue="id"
                            options={{ InputProps: { autoComplete: 'off' } }}
                            resettable={true}
                            
                        />
                        : null
                } 

                    

                <ReferenceInput label="Persona Usuaria" source="clientId" reference="users" allowEmpty={false} perPage={100}>
                                <AutocompleteInput optionText={(record) =>  record?.name + ' ' + record?.surnames} resettable={true} />
                            </ReferenceInput>
                
               
            </FormTab>            
        </TabbedForm>
        
    )
   
}


/* -------------------------------------------------------
   FILTRO
------------------------------------------------------- */

const ObjectiveFilter = (props) => {


    useEffect(() => {
  
     
    }, []);


    return (
         <Filter {...props}>
            <TextInput label="Id" source="id" />
            <TextInput label="ID Cliente" source="clientId" />
            <TextInput label="Área" source="areaName" alwaysOn />
            <TextInput label="Persona Usuaria" source="clientName" alwaysOn />
            <TextInput label="Contrato" source="contractName" alwaysOn />
            

            
        </Filter>
    );
};

/* -------------------------------------------------------
   TRANSFORM
------------------------------------------------------- */

const toLocalISOString = (date) => {

  if (!date) return null;
  
  const d = new Date(date);

  const offset = d.getTimezoneOffset() * 60000;

  return new Date(d.getTime() - offset).toISOString().slice(0, 19);

};

const toISOString = (date) => {

  if (!date) return null;


  const d = new Date(date);


  return new Date(d.getTime()).toISOString().slice(0, 19);

};




const transformObjectiveEdit = data => ({

    ...data,

    createdDate: toLocalISOString(data.createdDate),

    targetDate: toLocalISOString(data.targetDate)

});


const transformObjectiveCreate = (data) => ({

    ...data,

    createdDate: moment(new Date()).format('yyyy-MM-DDTHH:mm:ss'), // Fecha actual local

    targetDate: toISOString(data.targetDate)

});

/*

const transformObjectiveEdit = data => ({
    ...data,
    createdDate: data.createdDate
        ? new Date(data.createdDate).toISOString().slice(0, 19) // yyyy-MM-ddTHH:mm:ss
        : null,
    targetDate: data.targetDate
        ? new Date(data.targetDate).toISOString().slice(0, 19)
        : null
});

const transformObjectiveCreate = (data) => ({
    ...data,
    createdDate: new Date().toISOString().slice(0, 19), // fecha actual en formato válido
    targetDate: data.targetDate
        ? new Date(data.targetDate).toISOString().slice(0, 19)
        : null
});
*/

